import React from "react";

import GridContainer from "../../mui-components/Grid/GridContainer";
import ItemGrid from "../../mui-components/Grid/GridItem";
import RegularCard from "../../mui-components/Card/RegularCard";
import MyFiSwapSuggestionsTable from "../../containers/domain/my-fi-swap-suggestion/MyFiSwapSuggestionsTable";

const MyFiSwapSuggestionsListingView = () => (
  <GridContainer>
    <ItemGrid xs={12}>
      <RegularCard
        title="Lista de sugestões de troca de renda fixa"
        content={<MyFiSwapSuggestionsTable />}
      />
    </ItemGrid>
  </GridContainer>
);

export default MyFiSwapSuggestionsListingView;
